<template>
	<div class="sub-foot">
		<!-- 导航列表 -->
		<NuxtLink v-for="(item, index) in tabList" :key="index" :to="getNavUrl(item)" class="foot-nav" :class="{ checked: isCurrentPage(item.path) }" @click.capture="handleNavClick(item)">
			<div>
				<i class="iconfont" :class="isCurrentPage(item.path) ? item.activeIcon : item.icon"></i>
			</div>
			<div class="foot-text">{{ item.text }}</div>
		</NuxtLink>

		<!-- 插槽，供 shopping-cart 使用 -->
		<slot></slot>
	</div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useAnalytics } from '@/composables/useAnalytics';

const route = useRoute();
const emit = defineEmits(['nav-click']);
const { trackEvent } = useAnalytics();

const currentRoute = ref('');
const companyId = computed(() => {
	const id = route.params.companyId;
	return id != null && id !== '' ? String(id) : '';
});

const isGxzz = useIsGxzzSite(() => route.params.companyId);
const gxzzNavButtonNameMap = Object.freeze({
	首页: '站点首页',
	全部商品: '全部商品',
	公司简介: '公司介绍',
});

watch(
	() => route.path,
	p => {
		currentRoute.value = p;
	},
	{ immediate: true }
);

const tabList = computed(() => {
	const home = {
		text: '首页',
		path: '/{{companyId}}',
		icon: 'icon-fuwuhaoxiaochengxutubiao_shouye01',
		activeIcon: 'icon-fuwuhaoxiaochengxutubiao_shouye02',
		needParams: false,
	};
	const shopGoods = {
		text: '本店商品',
		path: '/{{companyId}}/products',
		icon: 'icon-v2_shangpin-b',
		activeIcon: 'icon-v2_shangpin-a',
		needParams: false,
	};
	const allGoods = {
		text: '全部商品',
		path: '/{{companyId}}/products',
		icon: 'icon-v2_shangpin-b',
		activeIcon: 'icon-v2_shangpin-a',
		needParams: false,
	};
	const profile = {
		text: '公司简介',
		path: '/{{companyId}}/companyProfile',
		icon: 'icon-gongsijianjie2',
		activeIcon: 'icon-gongsijianjie1',
		needParams: false,
	};
	const classify = {
		text: '分类',
		path: '/{{companyId}}/c',
		icon: 'icon-v2fenlei-b',
		activeIcon: 'icon-v2fenlei-a',
		needParams: false,
	};
	const back = {
		text: '返回平台',
		path: '/',
		icon: 'icon-v2_fanhui-b',
		activeIcon: 'icon-v2_fanhui-a',
		needParams: false,
	};

	if (isGxzz.value) {
		return [home, classify, allGoods, profile, back];
	}
	return [home, shopGoods, classify, back];
});
companyId.value = route.params.companyId;

const handleNavClick = item => {
	if (isGxzz.value) {
		const buttonName = gxzzNavButtonNameMap[item?.text] || (item?.path === '/{{companyId}}' ? '站点首页' : '');
		if (buttonName) {
			trackEvent({
				module: '国械智造站点首页',
				eventCode: 'gxzz_subsites_homepage_click',
				eventName: '国械智造站点首页点击',
				attrName: 'button_name',
				attrCode: buttonName,
			});
		}
	}
	emit('nav-click', item);
};

// 生命周期
onMounted(() => {
	currentRoute.value = route.path;
});

// 检查是否是当前页面，将 {{companyId}} 替换为当前 companyId 后再比较
const isCurrentPage = configPath => {
	const path = configPath.replace(/\{\{companyId\}\}/g, companyId.value || '');
	const cleanConfigPath = path.startsWith('/') ? path.substring(1) : path;
	const cleanCurrentRoute = currentRoute.value.startsWith('/') ? currentRoute.value.substring(1) : currentRoute.value;
	return cleanCurrentRoute === cleanConfigPath;
};

// 统一生成导航地址
const getNavUrl = item => {
	let url = item.path;

	if (item.needParams && companyId.value) {
		url += `?companyId=${companyId.value}`;
	}

	return url.replace(/\{\{companyId\}\}/g, companyId.value || '');
};
</script>

<style scoped lang="scss">
.sub-foot {
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	height: calc(50px + env(safe-area-inset-bottom));
	display: flex;
	justify-content: space-between;
	align-items: center;
	background: #ffffff;
	box-shadow: 0px -2px 10px 0px rgba(99, 118, 159, 0.15);
	z-index: 999;
	padding: 0 16px;
	padding-bottom: env(safe-area-inset-bottom);

	.foot-nav {
		width: 56px;
		height: 50px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		font-size: 10px;
		padding: 6px 0 4px;
		text-decoration: none;
		color: inherit;

		.iconfont {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 24px;
			height: 24px;
			margin: 0 auto;
			font-size: 20px !important;
			margin-bottom: 2px;
		}
	}
}

/* 选中状态样式 */
.checked {
	.iconfont {
		color: #5e90f1;
	}

	.foot-text {
		display: flex;
		justify-content: center;
		align-items: center;
		color: #5e90f1;
	}
}

.foot-text {
	line-height: 14px;
}
</style>
